//import 'bootstrap';
// Import just what we need

//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';


import smoothscroll from 'smoothscroll-polyfill';


import initSliders from "./slider";
//import lazyLoadIframes from "./lazyLoadIframes";
//import scrollTop from "./top";
import parallaxOff from "./ifTouchDeviceParallaxOff";
import scrollDown from "./scrollDown";
import switchLanguage from "./languageSwitch";
import autoCalculateDropdownBackdropHeight from "./autoCalculateDropdownBackdropHeight";
import setupCategoryMenu from "./setupCategorySubMenu";
import stoofMoreFrontend from "./moreBlock";
//import sectionCheckViewport from "./sectionIfInViewportScroll";
import drawOnCanvas from "./drawLayoutCanvas";
import floatingContact from "./floatingContact";
import getJobCount from "./ajaxJobs";
import sectionJumperFindActive from "./sectionJumperFindActive";
import setScrollPadding from "./setScrollPadding";
//import intersectioObserverMagic from "./intersectionObserverMagic";
//import addSmokeEffects from "./addSmokeEffectsToCanvas";
import changeNavbarBackgroundColor from "./changeMenuBackgroundOnDropdownOpen";
import formControls from "./formControls";
import checkboxWithImage from "./checkboxWithImageControl";
import setupParallax from "./setupParallax";
//import headerScroll from "./headerScroll";
import gsapRunAll from "./gsapAnimations";
import removeCategoryAndShowDropdown from "./bigMenuOnMobile";
import listenForNavToggler from "./listenForNavToggler";
//import checkHeaderImage from "./checkIfHeaderImageToBright";
// images loaded ====> gsapRunAll() ????
import consentmanagerTrigger from "./consentmanagerTrigger";
import stoofColumnMoreFrontend from "./moreColumn";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load" // notice "resize" isn't in the list
});
function setDocHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
};
const killAllScrollTriggers = () => {
    let allScrollTriggers = ScrollTrigger.getAll();
    if(allScrollTriggers.length > 0){
        allScrollTriggers.forEach(trigger =>{
            trigger.kill();
        })
    }
}
document.onreadystatechange = () => {
    if (document.readyState === 'complete') {




        // remove first load class from dropdown menu (prevents animation on page load)
        document.addEventListener('show.bs.dropdown', ev => {
            const drop = ev.target.nextElementSibling;
            drop.classList.remove('stoof-load');
        })
    }
}
window.addEventListener('load', () =>{
    initSliders();
    switchLanguage();
    stoofMoreFrontend();
    sectionJumperFindActive();
    formControls();
    stoofColumnMoreFrontend();
    floatingContact();

    killAllScrollTriggers();
    gsapRunAll();
    parallaxOff();
    scrollDown();
    setupCategoryMenu();
    getJobCount();
    changeNavbarBackgroundColor();

    checkboxWithImage();
    setupParallax();
    //headerScroll();
    //removeCategoryAndShowDropdown();
    listenForNavToggler();
    drawOnCanvas();
    //checkHeaderImage();
    consentmanagerTrigger();
    setScrollPadding();
    smoothscroll.polyfill();
    setDocHeight();
});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    killAllScrollTriggers();
    autoCalculateDropdownBackdropHeight();
    sectionJumperFindActive();
    setupCategoryMenu();
    gsapRunAll();
    initSliders();
    setupParallax();
    //removeCategoryAndShowDropdown();
    drawOnCanvas();
    stoofColumnMoreFrontend(true);
    setScrollPadding();
    setDocHeight();
    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', function () {
    killAllScrollTriggers();
    autoCalculateDropdownBackdropHeight();
    gsapRunAll();
    initSliders();
    sectionJumperFindActive();
    setupCategoryMenu();
   // removeCategoryAndShowDropdown();
    drawOnCanvas();
    stoofColumnMoreFrontend(true);
    setScrollPadding();
    setDocHeight();
    setupParallax();
});
